module.exports = __webpack_public_path__ + "img/03titile_m.1adbf9c0.png";